/*
  Photo frames.

  Image frames (product cards, product gallery, thumbnails, menu and cart
  thumbs) are white so Turn 14 parts shot on white blend into them. Real
  photos (shop, dyno, cars, merch on a backdrop) looked boxed in by that white.

  Each framed image is shrunk to 24x24 and its outer ring of pixels read. If
  most of the ring is white or transparent it is a studio parts shot: the frame
  stays white. Otherwise it is a photo: the frame gets .is-photo, turns dark and
  the photo fills it. Re-checked on every load, so gallery image swaps update.
  If the image can't be read (cross-origin), nothing changes.
*/
(function () {
  var FRAMES = '.pcard__media, .product-media, .product-thumb, .mega__thumb, .cat-tile__img, .list-collection-thumb, .cart-thumb';
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = 24;
  var ctx = canvas.getContext('2d', { willReadFrequently: true });

  function isStudioShot(img) {
    ctx.clearRect(0, 0, 24, 24);
    ctx.drawImage(img, 0, 0, 24, 24);
    var d = ctx.getImageData(0, 0, 24, 24).data;
    var light = 0, total = 0;
    for (var y = 0; y < 24; y++) {
      for (var x = 0; x < 24; x++) {
        if (x > 1 && x < 22 && y > 1 && y < 22) continue; // outer two-pixel ring only
        var i = (y * 24 + x) * 4;
        total++;
        if (d[i + 3] < 20 || (d[i] > 236 && d[i + 1] > 236 && d[i + 2] > 236)) light++;
      }
    }
    return light / total >= 0.75;
  }

  function check(img) {
    var frame = img.closest(FRAMES);
    if (!frame || !img.naturalWidth) return;
    var studio;
    try { studio = isStudioShot(img); } catch (e) { return; }
    frame.classList.toggle('is-photo', !studio);
    // The main gallery stays square for every image: the owner wants the black
    // frame visible around tall and wide photos, not a frame that hugs the photo.
  }

  document.addEventListener('load', function (e) {
    if (e.target.tagName === 'IMG') check(e.target);
  }, true);

  function scan() {
    document.querySelectorAll(FRAMES).forEach(function (frame) {
      var img = frame.querySelector('img');
      if (img && img.complete) check(img);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
